import { Button, Stack, Typography, useTheme } from "@mui/material";
import { UserX } from "lucide-react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { useLogOut } from "web_myplann/Shared/Hooks/useLogOut";

const PageResources = Resources.Profile.MissingAdvisor;

export const MissingAdvisor = () => {
	const theme = useTheme();
	const { t } = useResource();
	const { logOut, isPending } = useLogOut();

	return (
		<Stack
			alignItems="center"
			gap={1.5}
			position="absolute"
			top="50%"
			left="50%"
			width="80%"
			sx={{ transform: "translate(-50%, -50%)" }}
		>
			<UserX size={48} color={theme.palette.deprecated.grey[600]} />
			<Typography variant="deprecatedH3">{t(PageResources.title)}</Typography>
			<Typography
				variant="deprecatedBody2"
				color={theme.palette.deprecated.grey[500]}
				textAlign="center"
				maxWidth={280}
			>
				{t(PageResources.description)}
			</Typography>
			<Button onClick={logOut} disabled={isPending}>
				{t(PageResources.logOut)}
			</Button>
		</Stack>
	);
};
